import { put } from 'redux-saga/effects';
import { errorHandler } from 'src/errorHandler/errorHandler';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';
import {
    REVOKE_ADMIN_PROXIES_FAILURE,
    REVOKE_ADMIN_PROXIES_SUCCESS,
} from 'src/pages/admin/redux/action/actionTypes.js';

import { revokeProxiesService } from 'src/pages/admin/redux/services/index.js';

export function* revokeProxies(action) {
    try {
        const result = yield revokeProxiesService(action.payload);
        yield put({ type: REVOKE_ADMIN_PROXIES_SUCCESS, payload: result });
    } catch (e) {
        logUiErrorToBackend(e, {
            apiEndPoint: `occ/v2/${localStorage.getItem('baseSiteId')}/proxy/${action.payload}`,
            requestPayload: action.payload
        });
        yield put({
            type: REVOKE_ADMIN_PROXIES_FAILURE,
            templateError: errorHandler('503'),
        });
    }
}
